package es.subastia.splash

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope

import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn

sealed class SplashDestination {
    object Main : SplashDestination()
    object Loading : SplashDestination()
}

class SplashViewModel : ViewModel() {

    val destination: StateFlow<SplashDestination> =
        kotlinx.coroutines.flow.flow {
            emit(SplashDestination.Main)
        }
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5_000),
            initialValue = SplashDestination.Loading
        )
}
